
export function map(object, func) {
	const entries = Object.entries(object).map(([key, value]) => [key, func(value, key)])
	return Object.fromEntries(entries)
}

export function filter(object, func = x => x !== undefined) {
	const entries = Object.entries(object)
	const filtered = entries.filter(([key, value]) => func(value, key))
	return Object.fromEntries(filtered)
}

export function partition(object, func) {
	const left = {}, right = {}
	const entries = Object.entries(object).forEach(([key, value]) => {
		(func(value, key) ? left : right)[key] = value
	})
	return [left, right]
}

export const hasKeys = object => (Object.keys(object).length > 0)